import { render, staticRenderFns } from "./InventarioItems.vue?vue&type=template&id=52fd235e&scoped=true"
import script from "./InventarioItems.vue?vue&type=script&lang=js"
export * from "./InventarioItems.vue?vue&type=script&lang=js"
import style0 from "./InventarioItems.vue?vue&type=style&index=0&id=52fd235e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd235e",
  null
  
)

export default component.exports